import { URL_ACCOUNT_TEAM } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { Notice, Strong, Text, TextLink, Inline } from 'braid-design-system';
import React from 'react';
import { useSelector } from 'react-redux';

import { clickAddTeamMember } from 'src/app/analytics/notifications';
import getTrackingAdapter from 'src/app/dataAnalytics';
import { NOTIFICATIONS_ADD_TEAM_MEMBERES_NOW_LINK_PRESSED } from 'src/app/dataAnalytics/schema/constants';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import { sendLinkEvent } from 'src/app/utils/analytics';
import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';
import type AppState from 'src/types/appState';
import type { TrackingEvent } from 'src/types/trackingData';

import translations from './.vocab';

interface Props {
  description: string;
}

export const AddTeamMembersCallout = ({ description }: Props) => {
  const tealium = useSelector((state: AppState) => state.tealium);
  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const { localiseRoute } = useLocalisedRoutes();

  const onClickAddTeamMember = () => {
    if (isPageAnalyticsEnabled) {
      const eventData: TrackingEvent = {
        eventName: NOTIFICATIONS_ADD_TEAM_MEMBERES_NOW_LINK_PRESSED,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendLinkEvent(tealium, clickAddTeamMember());
    }
  };
  const { t } = useTranslations(translations);
  return (
    <Notice tone="promote">
      <Inline space="xsmall" collapseBelow="tablet" align={['right', 'left']}>
        <Text>{description}</Text>
        <Text>
          <Strong>
            <TextLink
              href={localiseRoute(URL_ACCOUNT_TEAM)}
              target="_blank"
              onClick={onClickAddTeamMember}
            >
              {t('add-team-members-callout-link-text')}
            </TextLink>
          </Strong>
        </Text>
      </Inline>
    </Notice>
  );
};
